
// Vue
import { Prop } from 'vue-property-decorator';
import { Component, Mixins } from 'vue-mixin-decorator';
// Components
import BasePage from '@/pages/BasePage.vue';

/**
 * [SFR0004] 商品詳細 - 概要タブコンポーネント
 */
@Component
export default class ProductDetailDescription extends Mixins<BasePage>(
  BasePage
) {
  /** 概要 HTMLコンテンツ */
  @Prop({ default: '' })
  html!: string;
}
